import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateSearchComponent } from "../../templates/template-search/template-search.component";
import { SelectOption } from "../../templates/template-select/template-select.component";

@Component({
  selector: "app-prefix-idi",
  imports: [TemplateSearchComponent],
  templateUrl: "./prefix-idi.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-idi.component.less",
})
export class PrefixIdiComponent extends PrefixComponent<string> {
  @Input()
  public options: SelectOption[];
  public multiple: boolean;

  public constructor() {
    super();
    this.options = [];
    this.multiple = false;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["idi"];
  }
}
